export default "__VITE_ASSET__D0jM0Z3N__"